import React from 'react';
import { connect } from 'react-redux';
import { Stepper, Step, StepLabel } from 'material-ui';
import { SmallRaisedButton } from '../../tc-ui/small-buttons';
import R from 'ramda';
import moment from 'moment';

const ForContractRequestStepper = props => {
  const {
    // completionPercent,
    collection,
    rateDocId,
    defaultInvitees = [],
    signatures = [],
    originFrom,
    realActorEmail,
    acceptingDummyTemplate,
    deletingDraft,
    openRequestSig,
    acceptDummyTemplate,
    discardDraft,
    loading,
    draftType,
  } = props;
  const shouldDisableButtons = acceptingDummyTemplate || deletingDraft || loading;
  const isADraft = collection === 'draft';
  const accepted = !isADraft || signatures.some(obj => obj.signedAt);
  if (originFrom === 'edited' || draftType === 'buyerCopy') {
    return (
      <Stepper style={{ width: 'calc(100% - 200px)' }}>
        <Step>
          <StepLabel style={{ height: '32px', paddingLeft: 0 }}>
            <div style={{ textAlign: 'center' }}>
              Make Changes
            </div>
          </StepLabel>
        </Step>
        <Step>
          <StepLabel style={{ height: '32px', paddingLeft: 0 }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ textAlign: 'center' }} className="flex-center">
                <SmallRaisedButton
                  label="Discard Changes"
                  primary
                  labelStyle={{ padding: '0 4px', textTransform: 'none' }}
                  onClick={discardDraft}
                  disabled={shouldDisableButtons}
                />&nbsp;&nbsp;Or&nbsp;&nbsp;
                <SmallRaisedButton
                  label="Request Signatures"
                  secondary
                  labelStyle={{ padding: '0 4px', textTransform: 'none' }}
                  disabled={shouldDisableButtons}
                  onClick={() => openRequestSig({
                    invitees: defaultInvitees,
                    rateDocId,
                    signatures,
                  })}
                />&nbsp;&nbsp;Or&nbsp;&nbsp;
                <SmallRaisedButton
                  label="Accept Changes"
                  secondary
                  labelStyle={{ padding: '0 4px', textTransform: 'none' }}
                  onClick={() => {
                    if (realActorEmail === 'admin@tourconnect.com') {
                      window.alert(`Mike!!!! We talked about this 100 times, don't click on this button!!!!`);
                      return;
                    }
                    acceptDummyTemplate({
                      rateDocId,
                    });
                  }}
                  disabled={shouldDisableButtons}
                />
              </div>
              {
                Boolean(signatures.length) && (
                  <small
                    style={{ display: 'block', marginLeft: '150px' }}
                  >Last requested on {moment(R.last(signatures).inviteSentAt).format('l')}</small>
                )
              }
            </div>
          </StepLabel>
        </Step>
      </Stepper>
    );
  }
  return (
    <Stepper style={{ width: 'calc(100% - 200px)' }}>
      <Step>
        <StepLabel style={{ height: '32px', paddingLeft: 0 }}>
          <div style={{ textAlign: 'center' }}>
            Create Rate Sheet
          </div>
        </StepLabel>
      </Step>
      <Step>
        <StepLabel style={{ height: '32px', paddingLeft: 0 }}>
          <div style={{ textAlign: 'center' }}>
            Enter Rates & Required Information
          </div>
        </StepLabel>
      </Step>
      <Step>
        <StepLabel style={{ height: '32px' }}>
          {
            (() => {
              if (accepted || originFrom !== 'initial') {
                return (
                  <div style={{ textAlign: 'center', width: '100%', display: 'flex', alignItems: 'center' }}>
                    Review
                  </div>
                );
              }
              if (signatures.length) {
                return (
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '16px' }}>
                    <SmallRaisedButton
                      label="Resend Signature Request"
                      secondary
                      labelStyle={{ padding: '0 4px', textTransform: 'none' }}
                      disabled={shouldDisableButtons}
                      onClick={() => openRequestSig({
                        invitees: defaultInvitees,
                        rateDocId,
                        signatures,
                      })}
                    />
                    <small>Last requested on {moment(R.last(signatures).inviteSentAt).format('l')}</small>
                  </div>
                );
              }
              return (
                <div style={{ textAlign: 'center', width: '100%', display: 'flex', alignItems: 'center' }}>
                  Review or&nbsp;
                  <SmallRaisedButton
                    label="Request Signatures"
                    secondary
                    labelStyle={{ padding: '0 4px', textTransform: 'none' }}
                    disabled={shouldDisableButtons}
                    onClick={() => openRequestSig({
                      invitees: defaultInvitees,
                      rateDocId,
                      signatures,
                    })}
                  />
                </div>
              );
            })()
          }
        </StepLabel>
      </Step>
      <Step>
        <StepLabel style={{ height: '32px', paddingRight: 0 }}>
          <div style={{ textAlign: 'center' }}>
            {
              (() => {
                if (accepted) {
                  return 'Accepted';
                }
                return (
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '16px' }}>
                    <SmallRaisedButton
                      label="Accept"
                      secondary
                      disabled={shouldDisableButtons}
                      labelStyle={{ padding: '0 4px', textTransform: 'none' }}
                      style={{ marginRight: '4px', width: '140px' }}
                      onClick={() => {
                        if (realActorEmail === 'admin@tourconnect.com') {
                          window.alert(`Mike!!!! We talked about this 100 times, don't click on this button!!!!`);
                          return;
                        }
                        acceptDummyTemplate({
                          rateDocId,
                        });
                      }}
                    />
                    <small>By {realActorEmail}</small>
                  </div>
                );
              })()
            }
          </div>
        </StepLabel>
      </Step>
    </Stepper>
  );
};

ForContractRequestStepper.propTypes = {
  completionPercent: React.PropTypes.number,
  collection: React.PropTypes.string,
  acceptedBy: React.PropTypes.array,
  rateDocId: React.PropTypes.string,
  defaultInvitees: React.PropTypes.array,
  signatures: React.PropTypes.array,
  originFrom: React.PropTypes.string,
  draftType: React.PropTypes.string,
  editHistory: React.PropTypes.array,
  realActorEmail: React.PropTypes.string,
  openRequestSig: React.PropTypes.func,
  acceptDummyTemplate: React.PropTypes.func,
  acceptingDummyTemplate: React.PropTypes.bool,
  discardDraft: React.PropTypes.func,
  deletingDraft: React.PropTypes.bool,
  loading: React.PropTypes.bool,
};

export default connect(({ dummyAcct, user }) => ({
  ...dummyAcct.rateDocIframe,
  realActorEmail: user.get('realActorEmail'),
}), {
  acceptDummyTemplate: payload => ({
    type: '{dummy-account} RateDocIframe_checkIfRateComplete',
    next: '{dummy-account} ACCEPT_DUMMY_TEMPLATE',
    payload,
    shouldBlock: true,
  }),
  discardDraft: () => ({
    type: '{dummy-account} DISCARD_DUMMY_TEMPLATE_DRAFT',
  }),
  openRequestSig: payload => ({ type: '{dummy-account} RateDocIframe_checkIfRateComplete', next: '{dummy-account}OPEN_REQUEST_SIGNATURE', payload }),
})(ForContractRequestStepper);



// WEBPACK FOOTER //
// ./src/app/components/contracting/dummy-account/for-contract-request.jsx